export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? 'https://sdajr7v62b.execute-api.eu-west-2.amazonaws.com/dev';

export const buildApiUrl = (path: string): string => {
  const base = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
};
